<template>
  <div class="hidden flex-col gap-4 p-4 2xl:flex">
    <RouterLink
      v-for="menuEntry in menuEntries"
      :key="menuEntry.id"
      :to="menuEntry.route"
      class="flex aspect-square w-12 items-center justify-center squircle-md rounded bg-white p-1 shadow-xl"
    >
      <img :src="menuEntry.img.src" />
    </RouterLink>
  </div>
</template>

<script>
import { partnerMenuEntries } from '@/views/layouts/main-layout/partnerMenuEntries'

export default {
  name: 'RightMenu',
  computed: {
    menuEntries() {
      return partnerMenuEntries((module) =>
        this.$functionality.module.has(module)
      )
    }
  }
}
</script>
